import { IconButton, Page, Sidebar } from "@eisox/design-system";
import { PanelLeftIcon } from "@eisox/icons";
import { useMediaQuery } from "@eisox/tools";
import { createFileRoute, useLocation } from "@tanstack/react-router";

import { requirePagePermission } from "~/helpers/auth/route-permission.helper";
import { buildingPageHead } from "~/helpers/document-title.helper";
import { getResourcesUrl } from "~/helpers/resources.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/resources/$")({
  beforeLoad: ({ context: { permissions }, params: { buildingId }, preload }) => {
    requirePagePermission(permissions, "ressource", buildingId, preload);
  },
  head: ({ match: { context }, params: { buildingId } }) =>
    buildingPageHead(context.queryClient, buildingId, m.assistance()),
  component: RouteComponent,
});

function RouteComponent() {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { _splat: splat } = Route.useParams();
  const { pathname, hash } = useLocation();

  return (
    <Page.Root>
      {isMobile && (
        <Page.Header>
          <Sidebar.Trigger asChild>
            <IconButton>
              <PanelLeftIcon />
            </IconButton>
          </Sidebar.Trigger>
          <Page.Title>{m.assistance()}</Page.Title>
        </Page.Header>
      )}
      <Page.Content className="mt-2.5 md:mt-10" data-testid="Resources">
        <iframe
          id="eisoxDocumentation"
          title="eisox documentation"
          src={getResourcesUrl(import.meta.env.VITE_RESSOURCES_URL, { splat, pathname, hash })}
          className="h-full w-full border-0"
        />
      </Page.Content>
    </Page.Root>
  );
}
